import { TextField } from "@mui/material";
import { MRT_Row, MRT_RowData } from "material-react-table";
import { useCallback, useMemo } from "react";

interface CustomCantidadInputProps<T extends MRT_RowData> {
  row: MRT_Row<T>;
  value: string | number;
  handleValue: (value: string) => void;
  disabled?: boolean
}
const CustomCantidadInput = <T extends MRT_RowData>({
  row,
  value,
  handleValue,
  disabled = false
}: CustomCantidadInputProps<T>) => {
  const handleKeyDown = useMemo<React.KeyboardEventHandler<HTMLDivElement> | undefined>(() => (event) => {
    if (['e', 'E', '-', '.', ','].includes(event.key)) {
      event.preventDefault();
    }
  }, []);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

      const raw = e.target.value.trim();
      const stripped = raw.replace(/^0+/, '');
      const value = stripped === '' ? '0' : stripped;
      handleValue(value);

    },
    [handleValue, row.original.codigo]
  );

  return (
    <TextField
      disabled={disabled}
      type="number"
      size="small"
      variant="outlined"
      inputProps={{ min: 0, step: 1 }}
      aria-label="Cantidad del producto"
      autoComplete="off"
      autoCorrect="off"
      autoFocus={false}
      //value={row.original.cantidad || "0"}
      value={value || "0"}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
    />
  );
};

export default CustomCantidadInput;
